<template>
  <v-card :color="cardColor">
    <v-card-text>
      <v-row>
        <v-col cols="12" class="pt-0 pl-4">
          <span class="kbDarkBlueText--text text-h5">
            {{ $t('general.addTask') }}
          </span>
        </v-col>

        <v-col cols="12" class="py-0">
          <v-text-field color="kbDarkBlueText"
                        :background-color="inputsBackground"
                        :label="$t('general.enterTaskName')"
                        :rules="[rules.required]"
                        solo
                        validate-on-blur
                        v-model="task.name"/>
        </v-col>

        <v-col cols="12" class="pt-0">
          <v-textarea color="kbDarkBlueText"
                      :background-color="inputsBackground"
                      height="80px"
                      hide-details
                      :label="$t('general.observations')"
                      solo
                      v-model="task.observation"/>
        </v-col>

        <v-col cols="12">
          <span class="kbDarkBlueText--text text-h6">
            {{ $t('general.timeToFinishTheTaskAfterRuleGetsExecuted') }}
          </span>
          <TimeMeasure :inputs-background="inputsBackground"
                       :time="task.after"
                       :time-units="task.timeUnits"
                       @onTimeUnitsChange="task.timeUnits = $event"
                       @onTimeChange="task.after = $event"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import rules from '@/libs/rules'
import TimeMeasure from '@/pages/App/Sequences/widgets/TimeMeasure'
export default {
  components: { TimeMeasure },
  computed: {
    cardColor () {
      return this.isCardWhite ? 'kbWhite' : 'kbLight'
    },
    inputsBackground () {
      return this.isCardWhite ? 'kbLight' : 'kbWhite'
    }
  },
  data () {
    return {
      rules
    }
  },
  props: {
    isCardWhite: {
      type: Boolean,
      default: false
    },
    task: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
